import { REGEX } from "../constants/regex";
import { STRING } from "../constants/string";

export class DomUtil {
  static hasClass(element: any, className: string): boolean {
    if (element && className) {
      if (element.classList) {
        return element.classList.contains(className);
      }
      return REGEX.FIND_CLASS_NAME(className).test(element.className);
    }

    return false;
  }

  static isHidden(element: HTMLElement): boolean {
    return !element || element.offsetParent === null;
  }
}
